import React, { FC } from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';

export const CardDataSection: FC<{
  caption: string;
  className?: string;
  lastSection?: boolean;
  id?: string;
  children?: React.ReactNode;
}> = ({ children, caption, className, lastSection = false, id }) => (
  <div
    data-testid={`${id}-card-section`}
    className={classNames(styles.section, className, {
      [styles.lastSection]: lastSection,
    })}
  >
    <div className={styles.caption}>{caption}</div>
    <div>{children}</div>
  </div>
);
